import {useTranslation} from '@/translations/i18n'
import {DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import {Text} from '@/components/ui/text/Text'
import {HttpGetProjectNotesResponse} from '../../http/projects.http'

export const ActivitiesSection = ({activities}: {activities: HttpGetProjectNotesResponse}) => {
    const {t} = useTranslation()

    return (
        <DetailsFieldsSection variant="neutral" title={t('projects:activities')}>
            <Text palette="neutral" shade="400" size="textSm" weight="500">
                {activities.note}
            </Text>
        </DetailsFieldsSection>
    )
}
